import { render, staticRenderFns } from "./ErrorLayout.vue?vue&type=template&id=2d67f674&scoped=true&"
import script from "./ErrorLayout.vue?vue&type=script&lang=js&"
export * from "./ErrorLayout.vue?vue&type=script&lang=js&"
import style0 from "./ErrorLayout.vue?vue&type=style&index=0&id=2d67f674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67f674",
  null
  
)

export default component.exports